import React from 'react';

const NoSlotsAvailable = () => (
  <p className="font-style-italic text-center">Sorry, there are no available times for this day.</p>
)

export default NoSlotsAvailable;
